<template>

<m-mobile-autocomplete
    :value="internal_value"
    :items="items"
    :search="doSearch"
    v-on:input="onInput"
    :label="label"
    placeholder="Search Country/Subdivision"
/>

</template>

<script>
const device = require('@/js/device.js');

export default {
    props: {
        value: {
            type: [String, Object],
            default: function() { return null; },
        },
        
        label: {
            type: String,
            default: function() { return "Headquarter's Location"; },
        },

        autofocus: {
            type: Boolean,
            default: function() { return false; },
        },

        'return-object' : {
            type: Boolean,
            default: function() { return false; }
        },
    },

    data() {
        return {
            internal_value: null,
            items: [],
            search: null,
            is_loading: false, 
        }
    },

    mounted () {
        this.internal_value = this.value;
        if ( this.value == null )
            this.doSearch('');
    },

    methods: {
        onInput(val) {

            if ( val == null )
            {
                this.$emit('input', null);
                this.internal_value = null;
                this.search = null;
                return;
            }

            if ( this['return-object'] )
            {
                this.$emit('input', val);
            }
            else
            {
                this.$emit('input', val.value);
            }

            this.internal_value = val;
        },

        passAllItems(item, queryText, itemText)
        {
            return true;
        },

        doSearch(val)
        {
            this.is_loading = true;

            let full_text_search = val;

            this.$rc.searchCountryAndSubdivisionFullText(
                {
                    'search_country_codes' : [],
                    'full_text' : full_text_search === null ? "" : full_text_search,
                },

                (data) => {
                    this.is_loading = false;
                    this.items = data.results;
                },

                () => {
                    this.is_loading = false;
                    this.items = [];
                }
            );
        },

        autocompleteMenuProps() {
            return device.autocompleteMenuProps();
        },
    },

    watch: {
        value(val) {

            if ( val == null )
            {
                this.items = null;
                this.internal_value = null;
                this.search = null;
                return;
            }

            else if ( typeof val === 'string' )
            {
                // assume the type is a country code

                this.is_loading = true;
                this.$rc.searchCountryAndSubdivisionFullText(

                    {
                        'search_country_codes' : [],
                        'full_text' : val === null ? "" : val,
                    },

                    (data) => {
                        this.is_loading = false;

                        this.items = data.results;

                        if ( this.items.length == 0 )
                        {
                            this.internal_value = null;
                            this.search = null;
                            return;
                        }
                        else
                        {
                            this.internal_value = this.items[0];
                            this.search = this.items[0].value;
                        }
                    },

                    () => {
                        this.is_loading = false;
                        this.items = [];
                    }

                );
            }
        },

        search(val) {
            this.doSearch(val);
        }
    },
}

</script>

<style lang="scss" scoped>

</style>